import { render, staticRenderFns } from "./HelpDocumentPage.vue?vue&type=template&id=c75b38ee&scoped=true&"
import script from "./HelpDocumentPage.vue?vue&type=script&lang=js&"
export * from "./HelpDocumentPage.vue?vue&type=script&lang=js&"
import style0 from "./HelpDocumentPage.vue?vue&type=style&index=0&id=c75b38ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75b38ee",
  null
  
)

export default component.exports